var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setup-container" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.$t("newWizartV2.uploadTrackingCodeToYourWebsite")) +
          "\n    "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [_c("InstallCode")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }